<div class="flex h-full w-full">
  <div class="grid h-full w-[288px] shrink-0 rounded-r-4xl bg-background-white shadow-card">
    <lib-teeth-highlight [selectedPosition]="selectedPosition()" [teeth]="teeth()" (teethSelect)="onToothSelect($event)" />

    @if (!isEditMode) {
      <div class="flex justify-center">
        <button class="btn-text" (click)="onModifySelectionClick()">
          {{ 'charting_add_treatment_modify_selection_button' | translate }}
        </button>
      </div>
    }
  </div>
  <div class="box-border flex flex-1 flex-col gap-4 p-4">
    <div class="flex shrink-0 flex-col gap-2 pe-4">
      <div class="flex items-center justify-between">
        <div class="typo-h2 inline-flex text-text-primary">{{ 'charting_add_treatment_surface_selector_title' | translate }}</div>
        <button class="inline-flex" (click)="onCloseClick()">
          <svg-icon class="text-text-primary" key="px-24-x" size="md"></svg-icon>
        </button>
      </div>
    </div>

    <div class="flex flex-1 flex-col rounded-[20px] border border-background-white p-4 pt-3">
      <div class="mb-[60px]">
        <div class="flex h-8 items-center justify-between">
          <div class="flex items-center gap-2">
            <div class="typo-h4-semibold text-primary-blue">{{ dialogData.treatment.dentalCode }}</div>
            @if (dialogData.treatment.longDescription) {
              <svg-icon
                class="shrink-0 text-text-light"
                key="px-16-info"
                size="sm"
                [libUiTooltip]="treatmentTooltip"
                tooltipPosition="bottom"
              />
              <ng-template #treatmentTooltip>
                <div class="typo-h5-book min-w-[18px]">{{ dialogData.treatment.longDescription }}</div>
              </ng-template>
            }
          </div>
        </div>
        <div class="flex justify-between gap-4 pr-1.5">
          <div class="typo-h4-medium text-text-primary">{{ dialogData.treatment.description }}</div>
        </div>
      </div>

      <div class="flex justify-center">
        <lib-surface-selector [formControl]="currentToothControl()" [selectedPosition]="selectedPosition()" />
      </div>
    </div>

    <div class="flex items-center justify-end gap-6">
      <button class="btn-text" (click)="onCloseClick()">{{ 'charting_add_treatment_cancel_button' | translate }}</button>
      @if (dialogData.selectedTeeth.length > 1) {
        <button class="btn-secondary shadow-none" [disabled]="applyButtonDisabled()" (click)="onApplyToAllClick()">
          {{ 'charting_add_treatment_apply_to_all_button' | translate }}
        </button>
      }
      <button class="btn-primary shadow-none" [disabled]="applyButtonDisabled()" (click)="onApplyClick()">
        {{ 'charting_add_treatment_apply_button' | translate }}
      </button>
    </div>
  </div>
</div>
